import { useState } from 'react'

// Import Worker
import { Worker } from '@react-pdf-viewer/core';
// Import the main Viewer component
import { LoadError, Viewer } from '@react-pdf-viewer/core';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
// default layout plugin
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import styles of default layout plugin
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useEffect } from 'react'
import Pubmed from './Pubmed.tsx';



function PDF({ url, highlightText }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const { toolbarPluginInstance } = defaultLayoutPluginInstance;
  const { searchPluginInstance } = toolbarPluginInstance;
  const { highlight } = searchPluginInstance;
  const [isDocumentLoaded, setDocumentLoaded] = useState(false);
  const handleDocumentLoad = async (e) => {

    setDocumentLoaded(true);
  }
  const [error, setError] = useState(false)


  const renderError = (error: LoadError) => {
    if (error) {
      setError(true)
      console.log('ERROR RENDERING PDF');
      return true
    }
    else {
      return false
    }
  }

  const [pdfFile] = useState(decodeURIComponent(url));
  // eslint-disable-next-line
  useEffect(async () => {
    if (isDocumentLoaded && highlightText) {
      let highlightFormatted = decodeURIComponent(highlightText)
      const findBestHighlight = async (length) => {
        let highlightKeyword = highlightFormatted.split(' ').slice(0, length).join(' ').replace(/ \n/g, '').replace(/\n/g, '')
        let h = await highlight({
          keyword: highlightKeyword,
          matchCase: false,
        });
        if (h.length === 0) {
          let o = await highlight({
            keyword: highlightKeyword.replace('  ', ' ').replace(/\s\s+/g, ' '),
            matchCase: false,
          });
          if (o && o.length > 0) {
            return true
          }
          else {
            return false
          }
        }
        else {
          return false
        }
      }
      let length = highlightFormatted.length - 1;
      let found = false;
      while (!found && length >= 4) {
        found = await findBestHighlight(length);
        length -= 5;
      }
    }
    // eslint-disable-next-line
  }, [isDocumentLoaded, highlightText]);

  return (
    <div className="container">
      {/* Upload PDF */}
      {error === true &&
        <Pubmed url={pdfFile} highlightText={highlightText} />
      }
      {/* View PDF */}
      <div className="viewer">
        {/* render this if we have a pdf file */}
        {pdfFile && !error && (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js">
            <Viewer defaultScale={1}
              renderError={renderError}
              fileUrl={pdfFile} onDocumentLoad={handleDocumentLoad}
              plugins={[defaultLayoutPluginInstance]}>

            </Viewer>
          </Worker>
        )}

        {/* render this if we have pdfFile state null   */}
        {!pdfFile && <>No PDF rendered</>}


      </div>

    </div>
  );
}

export default PDF;
